/*

Tea Selection Quiz for The Tea Brewery
written by: hey@alexrafuse.com
https://stacked.dev
March 22, 2025

*/




const STOREFRONT_ACCESS_TOKEN = '9f0c1055ac15f6527f9e188c4856d435';
// const STOREFRONT_ACCESS_TOKEN = '{{ shop.storefront_access_token }}';
// Note: We'll need to update this in the liquid file to use the Liquid variable

class TeaQuiz {
  constructor(shopDomain) {
    this.shopDomain = shopDomain;
    this.form = document.getElementById('teaQuizForm');
    this.resultsContainer = document.getElementById('quizResults');
    this.questions = document.querySelectorAll('.quiz-question');
    this.currentQuestion = 1;
    this.totalQuestions = this.questions.length;
    this.debugOutput = document.getElementById('debugOutput');
    this.debugPanel = document.querySelector('.debug-panel');
    this.cachedProducts = null;
    this.loadingIndicator = document.getElementById('loadingIndicator');
    this.restartQuizBtn = document.getElementById('restartQuizBtn');
    this.allProducts = [];
    this.currentPage = 1;
    this.productsPerPage = 250;
    
    this.prevBtn = document.getElementById('prevBtn');
    this.nextBtn = document.getElementById('nextBtn');
    this.submitBtn = document.getElementById('submitBtn');
    this.progressIndicator = document.querySelector('.progress-indicator');
    this.progressSteps = document.querySelectorAll('.step');
    
    this.clearMemoryBtn = document.getElementById('clearMemoryBtn');
    

    
    // Flavor options
    this.flavorOptions = [
      'Almond', 'Anise', 'Apple', 'Beet', 'Bergamot', 'Berry', 'Blackberry', 'Blueberry', 'Cacao', 'Calendula', 
      'Carob', 'Carrot', 'Cherry', 'Chocolate', 'Chunmee', 'Cinnamon', 'Citrus', 'Clove', 'Coconut', 'Coffee', 
      'Cornflower', 'Cucumber', 'Currant', 'Dandelion', 'Echinacea', 'Elderberry', 'Elderflower', 'Eucalyptus', 
      'Fenugreek', 'Ginger', 'Grassy', 'Hibiscus', 'Holy Basil', 'Honey', 'Honeybush', 'Jasmine', 'Lavender', 
      'Lemon', 'Lemongrass', 'Licorice', 'Lime', 'Mango', 'Maple', 'Marigold', 'Marsmallow', 'Mate', 'Mint', 
      'Moringa', 'Muscatel', 'Nettle', 'Nutmeg', 'Orange', 'Orchid', 'Papaya', 'Peach', 'Pear', 'Peppermint', 
      'Pineapple', 'Popped Rice', 'Pomegranate', 'Pumpkin', 'Raspberry', 'Roasted Rice', 'Rose', 'Rosehip', 
      'Rosemary', 'Safflower', 'Sage', 'Sea Buckthorn', 'Spearmint', 'Spicy', 'St. John\'s Wort', 'Strawberry', 
      'Sunflower', 'Tomato', 'Tropical', 'Tulsa', 'Turmeric', 'Vanilla', 'Wild Rose'
    ];
    this.randomizeFlavorsBtn = document.getElementById('randomizeFlavorsBtn');
    this.flavorOptionsContainer = document.getElementById('flavorOptions');
    
    this.setupEventListeners();
    this.setupDebugPanel();
    this.updateProgressBar();
    this.initializeFlavorOptions();
    
    // Pre-load products after a short delay to allow the quiz to render first
    setTimeout(() => {
      this.preloadProducts();
    }, 1000);
  }

  setupEventListeners() {
    this.form.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
      checkbox.addEventListener('change', () => {
        this.validateCurrentQuestion();
      });
    });
    
    // Add event listeners for skip buttons
    this.form.querySelectorAll('.skip-button').forEach(skipButton => {
      skipButton.addEventListener('click', (e) => {
        e.preventDefault();
        
        // Get the current question
        const currentQuestionEl = document.querySelector(`.quiz-question[data-question="${this.currentQuestion}"]`);
        const questionType = currentQuestionEl.dataset.type;
        
        // Mark this question as skipped
        this.markQuestionAsSkipped(questionType);
        
        // Navigate to the next question
        this.navigateQuestion(1);
      });
    });
    
    // Add event listener for custom flavor input
    const customFlavorInput = document.getElementById('customFlavorInput');
    const addCustomFlavorBtn = document.getElementById('addCustomFlavorBtn');
    
    if (customFlavorInput && addCustomFlavorBtn) {
      addCustomFlavorBtn.addEventListener('click', () => {
        this.addCustomFlavor();
      });
      
      customFlavorInput.addEventListener('keypress', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.addCustomFlavor();
        }
      });
    }
    
    this.prevBtn.addEventListener('click', () => {
      this.navigateQuestion(-1);
    });
    
    this.nextBtn.addEventListener('click', () => {
      this.navigateQuestion(1);
    });
    
    this.submitBtn.addEventListener('click', () => {
      this.showResults();
    });
    
    this.restartQuizBtn.addEventListener('click', () => {
      this.restartQuiz();
    });
    
    if (this.clearMemoryBtn) {
      this.clearMemoryBtn.addEventListener('click', () => {
        this.clearMemory();
        alert('Memory cleared successfully!');
      });
    }
    
    if (this.randomizeFlavorsBtn) {
      this.randomizeFlavorsBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.randomizeFlavorOptions();
      });
    }
  }
  
  setupDebugPanel() {
    const toggleDebugBtn = document.getElementById('toggleDebugBtn');
    if (toggleDebugBtn) {
      toggleDebugBtn.addEventListener('click', () => {
        this.debugPanel.classList.toggle('hidden');
      });
    }
    
    const loadProductsBtn = document.getElementById('loadProductsBtn');
    if (loadProductsBtn) {
      loadProductsBtn.addEventListener('click', async () => {
        this.log('Loading products...');
        try {
          const products = await this.fetchProducts();
          this.cachedProducts = products;
          this.log(`Loaded ${products.length} products`);
          this.log(JSON.stringify(products.slice(0, 2), null, 2) + '...');
        } catch (error) {
          this.log('Error loading products: ' + error.message);
          console.error(error);
        }
      });
    }
    
    const toggleMetafieldsBtn = document.getElementById('toggleMetafieldsBtn');
    if (toggleMetafieldsBtn) {
      toggleMetafieldsBtn.addEventListener('click', () => {
        if (!this.cachedProducts) {
          this.log('No products loaded yet. Click "Load Products" first.');
          return;
        }
        
        const metafields = {};
        this.cachedProducts.forEach(({ node }) => {
          if (node.metafields) {
            node.metafields.forEach(metafield => {
              if (!metafields[metafield.key]) {
                metafields[metafield.key] = new Set();
              }
              metafields[metafield.key].add(metafield.value);
            });
          }
        });
        
        const displayMetafields = {};
        Object.keys(metafields).forEach(key => {
          displayMetafields[key] = Array.from(metafields[key]);
        });
        
        this.log('Available metafields and their values:');
        this.log(JSON.stringify(displayMetafields, null, 2));
      });
    }
    
    const clearDebugBtn = document.getElementById('clearDebugBtn');
    if (clearDebugBtn) {
      clearDebugBtn.addEventListener('click', () => {
        this.debugOutput.textContent = '';
      });
    }
  }
  
  log(message) {
    if (!this.debugOutput) return;
    
    if (typeof message === 'object') {
      message = JSON.stringify(message, null, 2);
    }
    this.debugOutput.textContent += message + '\n\n';
    this.debugOutput.scrollTop = this.debugOutput.scrollHeight;
  }

  navigateQuestion(direction) {
    const currentQuestionEl = document.querySelector(`.quiz-question[data-question="${this.currentQuestion}"]`);
    currentQuestionEl.classList.remove('active');
    
    this.currentQuestion += direction;
    
    const newQuestionEl = document.querySelector(`.quiz-question[data-question="${this.currentQuestion}"]`);
    newQuestionEl.classList.add('active');
    
    this.updateNavigationButtons();
    this.updateProgressBar();
  }
  
  updateNavigationButtons() {
    this.prevBtn.disabled = this.currentQuestion === 1;
    
    if (this.currentQuestion === this.totalQuestions) {
      this.nextBtn.classList.add('hidden');
      this.submitBtn.classList.remove('hidden');
    } else {
      this.nextBtn.classList.remove('hidden');
      this.submitBtn.classList.add('hidden');
    }
    
    this.validateCurrentQuestion();
  }
  
  validateCurrentQuestion() {
    const currentQuestionEl = document.querySelector(`.quiz-question[data-question="${this.currentQuestion}"]`);
    const checkboxName = currentQuestionEl.querySelector('input[type="checkbox"]').name;
    const isAnswered = this.form.querySelectorAll(`input[name="${checkboxName}"]:checked`).length > 0;
    
    this.nextBtn.disabled = !isAnswered;
    this.submitBtn.disabled = !isAnswered;
  }
  
  updateProgressBar() {
    const progressPercentage = (this.currentQuestion / this.totalQuestions) * 100;
    
    // Use requestAnimationFrame for smoother animation
    requestAnimationFrame(() => {
      this.progressIndicator.style.width = `${progressPercentage}%`;
    });
    
    this.progressSteps.forEach(step => {
      const stepNum = parseInt(step.dataset.step);
      if (stepNum <= this.currentQuestion) {
        step.classList.add('active');
      } else {
        step.classList.remove('active');
      }
    });
  }
  
  async showResults() {
    const formData = new FormData(this.form);
    const answers = {
      caffeine: formData.getAll('caffeine'),
      type: formData.getAll('type'),
      flavor: formData.getAll('flavor')
    };
    
    // Check if all questions were skipped
    const caffeineSkipped = formData.get('caffeine_skipped') === 'true';
    const typeSkipped = formData.get('type_skipped') === 'true';
    const flavorSkipped = formData.get('flavor_skipped') === 'true';
    
    if (caffeineSkipped && typeSkipped && flavorSkipped) {
      this.displayErrorMessage("You've skipped all questions! Please answer at least one question to find matching teas.");
      return;
    }
    
    this.log(`Quiz answers: ${JSON.stringify(answers)}`);
    this.log(`Skipped questions: caffeine=${caffeineSkipped}, type=${typeSkipped}, flavor=${flavorSkipped}`);
    
    // Store the form height before hiding it
    const formHeight = this.form.offsetHeight;
    this.form.classList.add('hidden');
    
    // Set minimum height on container to prevent page jump
    this.form.parentElement.style.minHeight = `${formHeight}px`;
    
    this.showLoading();

    try {
      // Check if products were already pre-loaded
      if (!this.allProducts.length) {
        this.log('Products were not pre-loaded, fetching now...');
        await this.fetchAllProducts();
      } else {
        this.log(`Using ${this.allProducts.length} pre-loaded products`);
      }
      
      this.log(`Finding matches among ${this.allProducts.length} products...`);
      
      // Use setTimeout to prevent UI freezing and allow the loading indicator to render
      setTimeout(() => {
        try {
          const matchedProducts = this.findMatches(this.allProducts, answers, {
            caffeineSkipped,
            typeSkipped,
            flavorSkipped
          });
          this.log(`Found ${matchedProducts.length} matching products`);
          
          this.displayResults(matchedProducts);
        } catch (error) {
          this.log('Error finding matches: ' + error.message);
          console.error('Error finding matches:', error);
          this.displayErrorMessage('Sorry, there was an error finding matching teas. Please try again.');
        } finally {
          this.hideLoading();
        }
      }, 100);
    } catch (error) {
      this.log('Error loading products: ' + error.message);
      console.error('Error loading products:', error);
      this.hideLoading();
      this.displayErrorMessage('Sorry, there was an error loading our tea collection. Please try again later.');
    }
  }

  async fetchAllProducts() {
    this.log('Fetching all products...');
    this.allProducts = [];
    let hasNextPage = true;
    let cursor = null;
    
    while (hasNextPage) {
      this.log(`Fetching page ${this.currentPage}...`);
      const pageProducts = await this.fetchProductsPage(cursor);
      
      if (pageProducts.pageInfo.hasNextPage) {
        cursor = pageProducts.pageInfo.endCursor;
        this.currentPage++;
      } else {
        hasNextPage = false;
      }
      
      this.allProducts = [...this.allProducts, ...pageProducts.edges];
      this.log(`Total products loaded: ${this.allProducts.length}`);
    }
    
    this.cachedProducts = this.allProducts;
    return this.allProducts;
  }

  async fetchProductsPage(cursor) {
    const query = `{
      products(
        first: ${this.productsPerPage}${cursor ? `, after: "${cursor}"` : ''},
        query: "available_for_sale:true AND custom.ingredients:*"
      ) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            id
            title
            handle
            tags
            onlineStoreUrl
            images(first: 1) {
              edges {
                node {
                  url
                }
              }
            }
            variants(first: 1) {
              edges {
                node {
                  id
                  price {
                    amount
                    currencyCode
                  }
                }
              }
            }
            metafields(
              identifiers: [
                {namespace: "custom", key: "caffeine_content"},
                {namespace: "custom", key: "taste_profile"},
                {namespace: "custom", key: "steep_time"},
                {namespace: "custom", key: "steep_length"},
                {namespace: "custom", key: "ingredients"}
                {namespace: "custom", key: "flavour_attributes"},
              ]
            ) {
              key
              value
            }
          }
        }
      }
    }`;

    try {
      const response = await fetch(`https://${this.shopDomain}/api/graphql`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN
        },
        body: JSON.stringify({ query })
      });
      
      if (!response.ok) {
        const errorText = await response.text();
        this.log(`API error: ${errorText}`);
        throw new Error(`API error: ${response.status} ${response.statusText}`);
      }

      const json = await response.json();
      
      if (json.errors) {
        this.log(`GraphQL errors: ${JSON.stringify(json.errors)}`);
        throw new Error('GraphQL errors: ' + JSON.stringify(json.errors));
      }
      
      return json.data.products;
    } catch (error) {
      this.log(`Error fetching products page: ${error.message}`);
      throw error;
    }
  }

  async fetchProducts() {
    if (this.allProducts.length) {
      return this.allProducts;
    }
    
    return this.fetchAllProducts();
  }

  findMatches(products, answers, skipped = {}) {
    this.log('Matching criteria:');
    this.log(`- Caffeine: ${skipped.caffeineSkipped ? 'SKIPPED' : answers.caffeine.join(', ')}`);
    this.log(`- Type: ${skipped.typeSkipped ? 'SKIPPED' : answers.type.join(', ')}`);
    this.log(`- Flavor: ${skipped.flavorSkipped ? 'SKIPPED' : answers.flavor.join(', ')}`);
    
    // Limit the number of products to process at once to prevent browser crashes
    const maxProductsToProcess = 500;
    const productsToProcess = products.slice(0, maxProductsToProcess);
    
    if (products.length > maxProductsToProcess) {
      this.log(`Warning: Processing only the first ${maxProductsToProcess} products to prevent performance issues`);
    }
    
    // Optimize by pre-processing the answers
    const hasCaffeineFilter = !skipped.caffeineSkipped && answers.caffeine.length > 0;
    const hasTypeFilter = !skipped.typeSkipped && answers.type.length > 0;
    const hasFlavorFilter = !skipped.flavorSkipped && answers.flavor.length > 0;
    
    // Convert flavor answers to lowercase once
    const normalizedFlavorAnswers = hasFlavorFilter ? 
      answers.flavor.map(f => f.toLowerCase()) : [];
    
    const matches = [];
    
    // Process products in batches to prevent UI freezing
    for (let i = 0; i < productsToProcess.length; i++) {
      const { node } = productsToProcess[i];
      
      // Skip products that don't have an online store URL
      if (!node.onlineStoreUrl) {
        continue; // Skip this product as it's not available in the online store
      }
      
      // Extract metafields once
      const metafields = {};
      if (node.metafields && Array.isArray(node.metafields)) {
        node.metafields.forEach(metafield => {
          if (metafield && metafield.key) {
            metafields[metafield.key] = metafield.value;
          }
        });
      }
      
      // Skip detailed logging for each product to improve performance
      // this.log(`Checking product: ${node.title}`);
      
      // Check caffeine
      if (hasCaffeineFilter) {
        if (!metafields.caffeine_content) {
          continue; // Skip this product
        }
        
        const caffeineContent = metafields.caffeine_content.toLowerCase();
        let caffeineMatch = false;
        
        for (const level of answers.caffeine) {
          if (caffeineContent.includes(level) || 
              (level === 'none' && (caffeineContent.includes('none') || caffeineContent.includes('caffeine free')))) {
            caffeineMatch = true;
            break;
          }
        }
        
        if (!caffeineMatch) {
          continue; // Skip this product
        }
      }
      
      // Check tea type
      if (hasTypeFilter) {
        if (!node.tags || !Array.isArray(node.tags)) {
          continue; // Skip this product
        }
        
        const tags = node.tags.map(tag => tag.toLowerCase());
        let typeMatch = false;
        
        for (const type of answers.type) {
          switch(type) {
            case 'green':
              if (tags.includes('green tea') || tags.includes('green')) {
                typeMatch = true;
              }
              break;
            case 'black':
              if (tags.includes('black tea') || tags.includes('black')) {
                typeMatch = true;
              }
              break;
            case 'herbal':
              if (tags.includes('herbal tea') || tags.includes('herbal') || 
                  tags.includes('rooibos') || tags.includes('chamomile')) {
                typeMatch = true;
              }
              break;
            case 'oolong':
              if (tags.includes('oolong tea') || tags.includes('oolong')) {
                typeMatch = true;
              }
              break;
            case 'rooibos':
              if (tags.includes('rooibos tea') || tags.includes('rooibos')) {
                typeMatch = true;
              }
              break;
            case 'wellness':
              if (tags.includes('wellness tea') || tags.includes('wellness') || 
                  tags.includes('health') || tags.includes('functional')) {
                typeMatch = true;
              }
              break;
            case 'white':
              if (tags.includes('white tea') || tags.includes('white')) {
                typeMatch = true;
              }
              break;
          }
          
          if (typeMatch) break;
        }
        
        if (!typeMatch) {
          continue; // Skip this product
        }
      }
      
      // Check flavor
      if (hasFlavorFilter) {
        // Create a combined text to search for flavors in multiple fields
        let combinedText = node.title.toLowerCase() || '';
        
        // Add metafields to the combined text
        if (metafields.flavour_attributes) {
          combinedText += ' ' + metafields.flavour_attributes.toLowerCase();
        }
        if (metafields.taste_profile) {
          combinedText += ' ' + metafields.taste_profile.toLowerCase();
        }
        if (metafields.ingredients) {
          combinedText += ' ' + metafields.ingredients.toLowerCase();
        }
        
        let flavorMatch = false;
        
        // Check if any selected flavor is in the combined text
        for (const flavor of normalizedFlavorAnswers) {
          if (combinedText.includes(flavor)) {
            flavorMatch = true;
            break;
          }
        }
        
        if (!flavorMatch) {
          continue; // Skip this product
        }
      }
      
      // If we got here, all filters passed
      matches.push(productsToProcess[i]);
      
      // Limit the number of matches to prevent performance issues
      if (matches.length >= 100) {
        this.log(`Limiting results to first 100 matches for performance`);
        break;
      }
    }
    
    return matches;
  }

  displayResults(matchedProducts) {
    const resultsGrid = this.resultsContainer.querySelector('.results-grid');
    resultsGrid.innerHTML = '';

    // If no products found, show a message
    if (matchedProducts.length === 0) {
      const noResults = document.createElement('div');
      noResults.className = 'no-results';
      noResults.innerHTML = `
        <h3>No matching teas found</h3>
        <p>Try adjusting your preferences to see more options.</p>
      `;
      this.resultsContainer.appendChild(noResults);
    } else {
      matchedProducts.forEach(({ node }) => {
        const imageUrl = node.images.edges[0]?.node.url || '';
        const productUrl = `/products/${node.handle}`;
        
        // Extract metafields
        const metafields = {};
        if (node.metafields && Array.isArray(node.metafields)) {
          node.metafields.forEach(metafield => {
            if (metafield && metafield.key) {
              metafields[metafield.key] = metafield.value;
            }
          });
        }
        
        // Get tea type from tags
        let teaType = '';
        if (node.tags && Array.isArray(node.tags)) {
          const tags = node.tags.map(tag => tag.toLowerCase());
          if (tags.includes('green tea') || tags.includes('green')) {
            teaType = 'Green Tea';
          } else if (tags.includes('black tea') || tags.includes('black')) {
            teaType = 'Black Tea';
          } else if (tags.includes('herbal tea') || tags.includes('herbal')) {
            teaType = 'Herbal Tea';
          } else if (tags.includes('oolong tea') || tags.includes('oolong')) {
            teaType = 'Oolong Tea';
          } else if (tags.includes('rooibos tea') || tags.includes('rooibos')) {
            teaType = 'Rooibos Tea';
          } else if (tags.includes('wellness tea') || tags.includes('wellness') || 
                    tags.includes('health') || tags.includes('functional')) {
            teaType = 'Wellness Tea';
          } else if (tags.includes('white tea') || tags.includes('white')) {
            teaType = 'White Tea';
          } else if (tags.includes('chamomile')) {
            teaType = 'Herbal Tea';
          }
        }
        
        // Get caffeine level class for styling
        let caffeineClass = 'caffeine-unknown';
        const caffeineContent = metafields.caffeine_content ? metafields.caffeine_content.toLowerCase() : '';
        if (caffeineContent.includes('high')) {
          caffeineClass = 'caffeine-high';
        } else if (caffeineContent.includes('medium')) {
          caffeineClass = 'caffeine-medium';
        } else if (caffeineContent.includes('low')) {
          caffeineClass = 'caffeine-low';
        } else if (caffeineContent.includes('none') || caffeineContent.includes('caffeine free')) {
          caffeineClass = 'caffeine-none';
        }

        const productCard = document.createElement('div');
        productCard.className = 'product-card';
        productCard.innerHTML = `
          <a href="${productUrl}" target="_blank" class="product-link">
            <div class="info-pill elegant-pill ${caffeineClass}">
              <span class="info-icon">i</span>
              <div class="info-popup">
                <div class="popup-content">
                  <p><strong>Type:</strong> ${teaType}</p>
                  <p><strong>Caffeine:</strong> ${metafields.caffeine_content}</p>
                </div>
              </div>
            </div>
            <img src="${imageUrl}" alt="${node.title}">
            <div class="tea-category-label">${node.title}</div>
          </a>
        `;

        resultsGrid.appendChild(productCard);

        console.log('Product card for', node.title, ':', {
          teaType,
          caffeineContent: metafields.caffeine_content,
          metafields,
          html: productCard.innerHTML
        });
      });
      
      // Add event listeners for caffeine pill hover
      document.querySelectorAll('.info-pill').forEach(pill => {
        // Use mouseenter/mouseleave for better hover behavior
        pill.addEventListener('mouseenter', () => {
          const popup = pill.querySelector('.info-popup');
          if (popup) {
            popup.classList.add('active');
          }
        });
        
        pill.addEventListener('mouseleave', () => {
          const popup = pill.querySelector('.info-popup');
          if (popup) {
            popup.classList.remove('active');
          }
        });
        
        // Also add click handler for mobile devices
        pill.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const popup = pill.querySelector('.info-popup');
          if (popup) {
            popup.classList.toggle('active');
          }
        });
      });
    }

    // Maintain the page height during transition
    const quizHeight = this.form.offsetHeight;
    this.resultsContainer.style.minHeight = `${quizHeight}px`;

    this.resultsContainer.classList.remove('hidden');
  }

  setupAddToCartButtons() {
    this.resultsContainer.querySelectorAll('.add-to-cart-button').forEach(button => {
      button.addEventListener('click', async (e) => {
        const variantId = e.target.dataset.variantId;
        await this.addToCart(variantId);
      });
    });
  }

  async addToCart(variantId) {
    const mutation = `
      mutation {
        cartCreate(
          input: {
            lines: [{ quantity: 1, merchandiseId: "${variantId}" }]
          }
        ) {
          cart {
            checkoutUrl
          }
        }
      }
    `;

    try {
      const response = await fetch(`https://${this.shopDomain}/api/graphql`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN
        },
        body: JSON.stringify({ query: mutation })
      });

      const json = await response.json();
      window.location.href = json.data.cartCreate.cart.checkoutUrl;
    } catch (error) {
      console.error('Error adding to cart:', error);
    }
  }

  restartQuiz() {
    this.resultsContainer.classList.add('hidden');
    
    this.form.classList.remove('hidden');
    
    this.form.reset();
    
    // Remove any skipped question markers
    this.form.querySelectorAll('input[name$="_skipped"]').forEach(input => {
      input.remove();
    });
    
    this.questions.forEach((question, index) => {
      question.classList.remove('active');
      if (index === 0) {
        question.classList.add('active');
      }
    });
    
    this.currentQuestion = 1;
    this.updateNavigationButtons();
    this.updateProgressBar();
    
    this.clearMemory();
    
    this.form.scrollIntoView({ behavior: 'smooth' });
  }

  clearMemory() {
    this.allProducts = [];
    this.cachedProducts = null;
    this.currentPage = 1;
    
    if (this.debugOutput) {
      this.debugOutput.textContent = '';
      
      setTimeout(() => {
        this.log('Memory cleared');
      }, 100);
    }
  }

  // Improve loading indicator behavior
  showLoading() {
    this.loadingIndicator.classList.remove('hidden');
    document.body.style.overflow = 'hidden'; // Prevent scrolling while loading
  }
  
  hideLoading() {
    this.loadingIndicator.classList.add('hidden');
    setTimeout(() => {
      document.body.style.overflow = ''; // Restore scrolling
    }, 500);
  }

  // Initialize flavor options with 15 random flavors
  initializeFlavorOptions() {
    if (!this.flavorOptionsContainer) return;
    
    this.flavorOptionsContainer.innerHTML = '';
    this.getRandomFlavors(15).forEach(flavor => {
      this.addFlavorOption(flavor);
    });
  }

  // Get random flavors from the list
  getRandomFlavors(count, excludeSelected = []) {
    const availableFlavors = this.flavorOptions.filter(flavor => !excludeSelected.includes(flavor));
    const shuffled = [...availableFlavors].sort(() => 0.5 - Math.random());
    return shuffled.slice(0, count);
  }

  // Add a single flavor option to the container
  addFlavorOption(flavor) {
    const label = document.createElement('label');
    label.innerHTML = `
      <input type="checkbox" name="flavor" value="${flavor.toLowerCase()}">
      <span>${flavor}</span>
    `;
    this.flavorOptionsContainer.appendChild(label);
    
    // Add change event listener to validate the question
    const checkbox = label.querySelector('input[type="checkbox"]');
    checkbox.addEventListener('change', () => {
      this.validateCurrentQuestion();
    });
  }

  // Randomize unselected flavor options
  randomizeFlavorOptions() {
    if (!this.flavorOptionsContainer) return;
    
    // Get currently selected flavors
    const selectedFlavors = Array.from(
      this.flavorOptionsContainer.querySelectorAll('input[type="checkbox"]:checked')
    ).map(checkbox => checkbox.value.charAt(0).toUpperCase() + checkbox.value.slice(1));
    
    // Remove unselected options
    Array.from(this.flavorOptionsContainer.querySelectorAll('label')).forEach(label => {
      const checkbox = label.querySelector('input[type="checkbox"]');
      if (!checkbox.checked) {
        label.remove();
      }
    });
    
    // Calculate how many new options to add
    const currentCount = this.flavorOptionsContainer.querySelectorAll('label').length;
    const newOptionsCount = 15 - currentCount;
    
    // Add new random options
    if (newOptionsCount > 0) {
      const newFlavors = this.getRandomFlavors(newOptionsCount, selectedFlavors);
      newFlavors.forEach(flavor => {
        this.addFlavorOption(flavor);
      });
    }
  }

  // New method to preload products in the background
  async preloadProducts() {
    try {
      if (this.debugOutput) {
        this.log('Pre-loading products in the background...');
      }
      
      // Show a subtle loading indicator if desired
      // this.showSubtleLoading();
      
      await this.fetchAllProducts();
      
      if (this.debugOutput) {
        this.log(`Successfully pre-loaded ${this.allProducts.length} products`);
      }
      
      // Hide the subtle loading indicator if used
      // this.hideSubtleLoading();
    } catch (error) {
      console.error('Error pre-loading products:', error);
      if (this.debugOutput) {
        this.log(`Error pre-loading products: ${error.message}`);
      }
      
      // If pre-loading fails, we'll try again when the user submits the quiz
      this.allProducts = [];
    }
  }

  // Optional subtle loading indicator methods
  showSubtleLoading() {
    // Create a subtle loading indicator if desired
    const subtleLoader = document.createElement('div');
    subtleLoader.id = 'subtleLoader';
    subtleLoader.innerHTML = '<small>Loading tea data...</small>';
    subtleLoader.style.position = 'fixed';
    subtleLoader.style.bottom = '10px';
    subtleLoader.style.right = '10px';
    subtleLoader.style.background = 'rgba(255,255,255,0.8)';
    subtleLoader.style.padding = '5px 10px';
    subtleLoader.style.borderRadius = '4px';
    subtleLoader.style.fontSize = '12px';
    subtleLoader.style.color = '#666';
    subtleLoader.style.zIndex = '100';
    document.body.appendChild(subtleLoader);
  }
  
  hideSubtleLoading() {
    const subtleLoader = document.getElementById('subtleLoader');
    if (subtleLoader) {
      subtleLoader.remove();
    }
  }

  // Add a new method to display error messages
  displayErrorMessage(message) {
    const resultsGrid = this.resultsContainer.querySelector('.results-grid');
    resultsGrid.innerHTML = '';

    const errorMessage = document.createElement('div');
    errorMessage.className = 'error-message';
    errorMessage.innerHTML = `
      <h3>Oops!</h3>
      <p>${message}</p>
    `;
    
    resultsGrid.appendChild(errorMessage);
    this.resultsContainer.classList.remove('hidden');
  }

  // Add a new method to mark questions as skipped
  markQuestionAsSkipped(questionType) {
    // Create a hidden input to mark this question as skipped
    let skipInput = document.querySelector(`input[name="${questionType}_skipped"]`);
    
    if (!skipInput) {
      skipInput = document.createElement('input');
      skipInput.type = 'hidden';
      skipInput.name = `${questionType}_skipped`;
      skipInput.value = 'true';
      this.form.appendChild(skipInput);
    }
    
    this.log(`Skipped question: ${questionType}`);
  }

  // Add a new method to handle custom flavor addition
  addCustomFlavor() {
    const customFlavorInput = document.getElementById('customFlavorInput');
    const flavor = customFlavorInput.value.trim();
    
    if (flavor) {
      // Check if this flavor already exists
      const existingFlavors = Array.from(
        this.flavorOptionsContainer.querySelectorAll('input[type="checkbox"]')
      ).map(checkbox => checkbox.value.toLowerCase());
      
      if (!existingFlavors.includes(flavor.toLowerCase())) {
        // Add the custom flavor
        this.addFlavorOption(flavor.charAt(0).toUpperCase() + flavor.slice(1).toLowerCase());
        
        // Find and check the newly added checkbox
        const newCheckbox = Array.from(
          this.flavorOptionsContainer.querySelectorAll('input[type="checkbox"]')
        ).find(checkbox => checkbox.value.toLowerCase() === flavor.toLowerCase());
        
        if (newCheckbox) {
          newCheckbox.checked = true;
          // Trigger the change event to update validation
          newCheckbox.dispatchEvent(new Event('change'));
        }
        
        // Clear the input
        customFlavorInput.value = '';
        
        // Focus back on the input for easy addition of multiple flavors
        customFlavorInput.focus();
      } else {
        // Highlight the existing flavor
        const existingLabel = Array.from(
          this.flavorOptionsContainer.querySelectorAll('label')
        ).find(label => 
          label.querySelector('input').value.toLowerCase() === flavor.toLowerCase()
        );
        
        if (existingLabel) {
          // Check the existing checkbox if it's not already checked
          const checkbox = existingLabel.querySelector('input');
          if (!checkbox.checked) {
            checkbox.checked = true;
            // Trigger the change event to update validation
            checkbox.dispatchEvent(new Event('change'));
          }
          
          existingLabel.classList.add('highlight');
          setTimeout(() => {
            existingLabel.classList.remove('highlight');
          }, 1500);
        }
        
        // Clear the input
        customFlavorInput.value = '';
      }
    }
  }
}

// Export for testing
if (typeof module !== 'undefined' && module.exports) {
  module.exports = {
    TeaQuiz,
    matchCaffeineLevel: TeaQuiz.prototype.matchCaffeineLevel,
    matchTeaType: TeaQuiz.prototype.matchTeaType
  };
}